import React from 'react';
import { dropdowns } from 'seal-ui-components';
import BoldLabel from '@Components/UI/Label';
import styled from 'styled-components';
import style from './SingleSelectDropdown.style';

const { Select, SelectOption } = dropdowns;

const SingleSelectDropdown = ({
    id,
    label,
    placeholder,
    selectedValue,
    options,
    onChange,
    className
}) => {
    const selectOptions =
        options &&
        options.length > 0 &&
        options.map(opt => (
            <SelectOption key={opt.key} value={opt} title={opt.text}>
                {opt.text}
            </SelectOption>
        ));

    return (
        <div className={className}>
            {label && <BoldLabel>{label}</BoldLabel>}
            <Select
                id={id}
                placeholder={placeholder}
                value={selectedValue}
                onChange={onChange}
                hideClear
                paddedMenu={false}
                appearance="secondary"
                shortenText={true}
                maxOptionsWidth={'2rem'}
                size="large"
            >
                {selectOptions}
            </Select>
        </div>
    );
};

export default styled(SingleSelectDropdown)`
    ${style};
`;
